// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__310pi","title":"AfterBackImages_title__37Eqm","images":"AfterBackImages_images__VN6D8"};